var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrevFrame = function SvgPrevFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 -880 760 790"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142z"
  })));
};
export default SvgPrevFrame;